import { Box, Typography } from '@mui/material';
import React from 'react'
import ic_announcement from "../img/ic_announcement.svg";
import CloseIcon from '@mui/icons-material/Close';
const BannerComp = ({setBanner}) => {
  return (
    <Box className="announcement-box" style={{background: "linear-gradient(90deg, #6943FF 0%, #A800FF 100%)"}} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', py: '12px' , px:{xs:'16px', md:'0px'}, fontSize: { xs: '12px', md: '14px' }, color: '#663C00', fontWeight: 500 }}>
    <Box flex={1} display={'flex'} alignItems={'center'} gap={1} marginLeft={'auto'} textAlign={'center'} justifyContent={'center'}>
      <Box  component={'img'} height={'16px'} src={ic_announcement} alt="speaker" />
      <Typography sx={{fontSize: {xs: '12px', sm: '16px'}, fontWeight: 600, color: "#fff"}}>Zaperon is now SOC 2 Type II Certified</Typography>
      </Box>
      <CloseIcon  sx={{ color: '#fff', fontSize: 18, stroke: "currentColor", strokeWidth: 2, cursor: 'pointer', position: 'relative', right: {sm: '10%', xs: '3%'}}} color="#fff" onClick={(e) => {  const box = e.currentTarget.closest(".announcement-box");
    if (box) {
      setBanner(false);
      box.style.display = "none";
      }}} />
    </Box>
  )
}

export default BannerComp